import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
    BaseUserService,
    ProfileEntity,
    Space,
} from "@smarterplan/ngx-smarterplan-core";

@Component({
    selector: "museum-header",
    templateUrl: "./museum-header.component.html",
    styleUrls: ["./museum-header.component.scss"],
})
export class MuseumHeaderComponent implements OnInit {
    spaceID: string;

    space: Space;

    isGuide = false;

    currentUser: ProfileEntity;

    constructor(
        private userService: BaseUserService,
        private route: ActivatedRoute,
    ) { }

    ngOnInit(): void {
        this.currentUser = this.userService.cu;
        this.route.children[0].params.subscribe(async (parameters) => {
            this.spaceID = parameters.id;
            this.isGuide = this.userService.isGuide(this.spaceID);
        });
    }
}
